import styled from 'styled-components';

export const ImgUploadBox = styled.div`
  width: 110px;
  height: 110px;
  margin: 0 auto 30px auto;
`;

export const ProfileForm = styled.form``;
